import styled from 'styled-components';

import { ThemeProp } from '../../../theme/Themes';
import Dropdown from '../Dropdown';

export const SimpleSelectDropdown = styled(Dropdown).attrs((props: ThemeProp) => {
  return {
    ...props,
    displayRadioIcon: false,
    buttonCSS: {
      color: props.theme.colors.black,
      background: `${props.theme.colors.greyscale.c900} !important`,
      height: '40px',
      width: 'auto',
      borderRadius: '1.5rem',
      borderColor: 'transparent',
      paddingLeft: '1.25rem',
      '&.nextui-dropdown-button:hover': {
        background: `${props.theme.colors.primary.c800} !important`,
        color: props.theme.colors.primary.c200,
        borderColor: 'transparent',
      },
      '&.nextui-dropdown-button:hover .nextui-button-icon-right': {
        stroke: props.theme.colors.primary.c200,
      },
      '&.nextui-dropdown-button:hover .nextui-button-text': {
        color: props.theme.colors.primary.c200,
      },
      '&.nextui-dropdown-button[aria-expanded=true]': {
        borderColor: 'transparent !important',
        background: `${props.theme.colors.primary.c800} !important`,
        color: props.theme.colors.primary.c200,
        opacity: '1 !important',
      },
      '&.nextui-dropdown-button[aria-expanded=true] .nextui-button-text': {
        color: props.theme.colors.primary.c200,
      },
      '&.nextui-dropdown-button[aria-expanded=true] .nextui-button-icon-right': {
        stroke: props.theme.colors.primary.c200,
      },
      '& .nextui-button-icon-right': {
        width: '1.25rem',
        height: '1.25rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: 0,
        stroke: 'black',
      },
      '& .nextui-button-text': {
        fontSize: props.theme.fontSize.s,
        width: 'auto',
      },
      '& .nextui-button-text div': {
        display: 'block',
        width: 'auto',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      },
      border: 'unset',
      boxShadow: props.theme.shadows.secondary,
    },
  };
})``;

export default SimpleSelectDropdown;
